import dayjs from "dayjs";
import { panLabels } from "../ConstantData";
import { Tooltip, Typography } from "antd";
import DataFormatter from "../../components/common/DataFormatter";

export const bankDetailstoArray = (obj = {}, isAggregate=false) => {
    const accountKeyObj = {
        bankName: "Bank Name",
        ifscCode: "IFSC & MICR Code",
        branchName: "IFSC branch name & address",
        accountNumber: "Account Number",
        accountType: "Account Type",
        accountAge: "Account Age",
        statementPeriod: "Statement period",
        sanctionedLimit: "Sanction Limit",
        unUtilisedAmount: "Unutilised Amount",
        noTxnMonth: "No transaction months",
        noTxnDates: "No transaction dates",
        monthsBeforeLastChqBounce: "Months since last Cheque bounce",
        accountHolderName: "Account holders",
        panNumber: "PAN",
        customerAddress: "Account holder address",
        phoneNumber: "Contact details"
    }
    console.log("ACCOUNT DETAILS >>>", obj);
    
    const accountDetails = obj.account;
    let _bankDetails = [];
    if(!accountDetails) return _bankDetails;
    for (let key in accountKeyObj) {
        if (key === "ifscCode") {
            let value = (accountDetails.ifscCode && accountDetails.micrCode) ?
                `IFSC: ${accountDetails.ifscCode}, MICR: ${accountDetails.micrCode}`
                : (accountDetails.ifscCode &&
                    `IFSC: ${accountDetails.ifscCode}`) ||
                (accountDetails.micrCode &&
                    `MICR: ${accountDetails.micrCode}`) ||
                '-';
            _bankDetails.push({ label: accountKeyObj[key], value });
        } else if (key === "branchName") {
            let value = (accountDetails.branchName && accountDetails.branchAddress) ?
                `${accountDetails.branchName} ${accountDetails.branchAddress}`
                : (accountDetails.branchName &&
                    `${accountDetails.branchName}`) ||
                (accountDetails.branchAddress &&
                    `${accountDetails.branchAddress}`) ||
                '-';
            _bankDetails.push({ label: accountKeyObj[key], value });
        } else if (key === "statementPeriod") {
            let value = accountDetails.startDate &&
                accountDetails.endDate
                ? `${accountDetails.statementPeriod} (${dayjs(
                    accountDetails.startDate
                ).format('DD/MM/YYYY')} - ${dayjs(
                    accountDetails.endDate
                ).format('DD/MM/YYYY')})`
                : '-';
            _bankDetails.push({ label: accountKeyObj[key], value });
        } else if (key === "noTxnMonth" || key === "noTxnDates") {
            console.log("key", accountDetails)
            let object = isAggregate? accountDetails: obj;
            let value = object[key]?.length > 0 ?
                <Tooltip placement='top' title={object[key].join(" , ")} overlayInnerStyle={{ width: 600 }}>
                    <Typography.Text className='eclips-text'>{object[key].join(" , ")}</Typography.Text>
                </Tooltip> : 0;
            _bankDetails.push({ label: accountKeyObj[key], value })
        } else if (key === "monthsBeforeLastChqBounce" && accountDetails.monthsBeforeLastChqBounce) {
            _bankDetails.push({ label: accountKeyObj[key], value: accountDetails[key] || "0" })
        } else if (key === "accountHolderName") {
            let value = (accountDetails.accountHolderName && accountDetails.jointHolderName)
                ? accountDetails.accountHolderName + ', ' + accountDetails.jointHolderName
                : accountDetails.accountHolderName.trim()
                    ? accountDetails.accountHolderName
                    : accountDetails.jointHolderName || '-';
            _bankDetails.push({ label: accountKeyObj[key], value })
        } else if (key === "panNumber") {
            let value = accountDetails[key] ?
                <>
                    {accountDetails[key]}
                    {
                        accountDetails.verifiedPan ?
                            <Typography.Text color={panLabels[accountDetails.verifiedPan].color}>{panLabels[accountDetails.verifiedPan].label}</Typography.Text>
                            : ""
                    }
                </> : "-";
            _bankDetails.push({ label: accountKeyObj[key], value })
        } else if (key === "phoneNumber") {
            let value = (accountDetails.email && accountDetails.phoneNumber)
                ? `E: ${accountDetails.email}, P: ${accountDetails.phoneNumber}`
                : (accountDetails.email &&
                    `E: ${accountDetails.email}`) ||
                (accountDetails.phoneNumber &&
                    `P: ${accountDetails.phoneNumber}`) ||
                '-';
            _bankDetails.push({ label: accountKeyObj[key], value })
        } else if (key === "sanctionedLimit") {
            if (accountDetails.type === "Overdraft / Cash credit Account") {
                let value = accountDetails.sanctionedLimit
                    .slice(0, 2)
                    .map((ele, index) => {
                        return index === 0 ? (
                            <div>
                                {ele.amount && ele.endDate && ele.startDate
                                    ? `₹${ele.amount} (${dayjs(ele.startDate).format(
                                        'DD/MM/YYYY'
                                    )} - ${dayjs(ele.endDate).format(
                                        'DD/MM/YYYY'
                                    )})${index === 1 ? '' : ','} `
                                    : '-'}
                            </div>
                        ) : ele.amount && ele.endDate && ele.startDate ? (
                            `₹${ele.amount} (${dayjs(ele.startDate).format(
                                'DD/MM/YYYY'
                            )} - ${dayjs(ele.endDate).format('DD/MM/YYYY')})${index === 1 ? '' : ','
                            } `
                        ) : (
                            '-'
                        );
                    })
                _bankDetails.push({ label: accountKeyObj[key], value })
            }
        } else if (key === "unUtilisedAmount") {
            if (accountDetails.type === "Overdraft / Cash credit Account") {
                let value = <DataFormatter>{accountDetails[key]}</DataFormatter>
                _bankDetails.push({ label: accountKeyObj[key], value })
            }
        } else {
            console.log("BANK NAME ISSUE", accountDetails, accountKeyObj);
            if(accountKeyObj[key]){
                _bankDetails.push({ label: accountKeyObj[key], value: accountDetails[key] || "-" });
            }
        }
    }
    return _bankDetails;
}

export const bankAccountsArray = (reportAccounts) => {

    const selectedKeys = [
        'accountHolderName', 
        'accountNumber', 
        'bankName', 
        'accountTypeName', 
        'email', 
        'phoneNumber', 
        'startDate', 
        'endDate', 
        'transactionStartDate', 
        'transactionEndDate'
    ];

    const formatLabel = (key) => {
        return key
          .replace(/([a-z])([A-Z])/g, '$1 $2') // Split camelCase words
          .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
    };

    const formatMap = {
        accountHolderName: (value) => value,
        accountNumber: (value) => value,
        bankName: (value) => value,
        accountTypeName: (value) => value,
        email: (value) => value,
        phoneNumber: (value) => value,
        startDate: (value) => value,
        endDate: (value) => value,
        transactionStartDate: (value) => value,
        transactionEndDate: (value) => value,
    };

    console.log("FOR EACH ISSUE:>>>", reportAccounts);
    

    const accountLists = selectedKeys?.map((key) => {
        const rowData = {
            key, 
            label: formatLabel(key),
        };

        reportAccounts?.forEach((accountData, index) => {
            let value = accountData.account[key] || '-';

            if (formatMap[key]) {
                value = formatMap[key](value);
            }

            // Assign the value directly using just the index (no 'account' prefix)
            rowData[`${index}`] = value;
        });
        
        return rowData;
    });

    return accountLists;
}